export default __webpack_public_path__ + "static/media/arial-unicode-ms.9c72e35f.ttf";